/* empty css            */
import { createContext, useContext, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/_overlay/PortalHost.tsx
/**
* Where overlays portal to. `undefined` (no provider) means document.body; `null` means
* a host is being mounted, so overlays wait a render rather than land in the wrong place.
*/
var PortalHostContext = createContext(void 0);
/** The portal container for overlays rendered here. */
function usePortalContainer() {
	const host = useContext(PortalHostContext);
	if (host !== void 0) return host;
	return typeof document === "undefined" ? null : document.body;
}
/**
* A portal host for a themed scope. Render `hostElement` as the scope element's last
* child and provide `host` through PortalHostContext: overlays opened inside then mount
* within the scope, so they inherit its data-brand, data-theme, density and accent.
*/
function usePortalHost() {
	const [host, setHost] = useState(null);
	return {
		host,
		hostElement: /* @__PURE__ */ jsx("div", {
			className: "ds-portal-host",
			"data-ds-portal-host": "",
			ref: setHost
		})
	};
}
//#endregion
export { PortalHostContext, usePortalContainer, usePortalHost };

//# sourceMappingURL=PortalHost.js.map